import { API_ENDPOINT } from "../config";

const API_URL = `${API_ENDPOINT}/equipment-templates`;

export const getEquipmentTemplates = async (
  category = null,
  subcategory = null,
) => {
  try {
    let url = `${API_URL}/list`;
    const params = [];

    if (category) params.push(`category=${encodeURIComponent(category)}`);
    if (subcategory)
      params.push(`subcategory=${encodeURIComponent(subcategory)}`);

    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    const response = await fetch(url);
    const data = await response.json();

    if (!data.success) {
      throw new Error(
        data.message || "Errore nel recupero dei template equipaggiamento",
      );
    }

    return data;
  } catch (error) {
    console.error("Error fetching equipment templates:", error);
    throw error;
  }
};

export const getEquipmentCategories = async () => {
  try {
    const response = await fetch(`${API_URL}/categories`);
    const data = await response.json();

    if (!data.success) {
      throw new Error(data.message || "Errore nel recupero delle categorie");
    }

    return data;
  } catch (error) {
    console.error("Error fetching equipment categories:", error);
    throw error;
  }
};

export const getEquipmentSubcategories = async (category) => {
  try {
    const response = await fetch(
      `${API_URL}/subcategories/${encodeURIComponent(category)}`,
    );
    const data = await response.json();

    if (!data.success) {
      throw new Error(
        data.message || "Errore nel recupero delle sottocategorie",
      );
    }

    return data;
  } catch (error) {
    console.error("Error fetching equipment subcategories:", error);
    throw error;
  }
};

export const getEquipmentTemplateById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/${id}`);
    const data = await response.json();

    if (!data.success) {
      throw new Error(
        data.message || "Errore nel recupero del template equipaggiamento",
      );
    }

    return data;
  } catch (error) {
    console.error("Error fetching equipment template:", error);
    throw error;
  }
};
